import { Action } from '@ngrx/store';

import { InventoryFilter } from '../shared/inventory-filter.model';

export const INV_SUM_INIT = '[INV SUM] - Initialize';
export const INV_SUM_CLEAR_FILTER = '[INV SUM] [FILTER] - Clear Filter';
export const INV_SUM_SELECT_ROW = '[INV SUM] [GRID] - Select Row';
export const INV_SUM_CLEAR_SELECT_ROW = '[INV SUM] [GRID] - Clear Selected Row';
export const INV_SUM_SET_FILTER = '[INV SUM] [FILTER] - Set Filter';
export const INV_SUM_SET_SHOWING = '[INV SUM] [MENU] - Change Showing Area';
export const INV_SUM_REQUEST_DATA = '[INV SUM] [GRID] - Request Data';

export const INV_DTL_INIT = '[INV DTL] - Initialize';
export const INV_DTL_SET_SHOWING = '[INV DTL] [MENU] - Change Showing Area';
export const INV_DTL_SELECT_ROW = '[INV DTL] [GRID] - Select Row';
export const INV_DTL_CLEAR_SELECT_ROW = '[INV DTL] [GRID] - Clear Selected Row';
export const INV_DTL_REQUEST_DATA = '[INV DTL] [GRID] - Request Data';

export const INV_ITEM_LOT_REQ_DATA = '[INV ITEM] [LOT REQUIRED VAL] - Request Data'

export const INV_ITEM_LOT_REQ_DATA_SUCESS = '[INV ITEM] [LOT REQUIRED Success] - Request Data'

export const INV_LOT_INIT = '[INV LOT] - Initialize';
export const INV_LOT_SET_SHOWING = '[INV LOT] [MENU] - Change Showing Area';
export const INV_LOT_REQUEST_DATA = '[INV LOT] [GRID] - Request Data';

export interface LotRequiredItem {
  item: string;
  custid: string;
  facility: any;
  lotrequired: string;
  status: string;
  statusabbrev: string;
  invstatus: string;
  inventoryclass: string;
  hazardous: string;
}



export enum InvSumShowing {
  filter = 'filter',
  colpref = 'colpref',
  grid = 'grid',
}

export enum InvDtlShowing {
  colpref = 'colpref',
  grid = 'grid',
}

export enum InvLotShowing {
  colpref = 'colpref',
  grid = 'grid',
}

export class InvSumInit implements Action {
  readonly type = INV_SUM_INIT;
}

export class InvSumSetFilter implements Action {
  readonly type = INV_SUM_SET_FILTER;
  constructor(public filter: InventoryFilter) {}
}

export class InvSumClearFilter implements Action {
  readonly type = INV_SUM_CLEAR_FILTER;
}

export class InvSumSetShowing implements Action {
  readonly type = INV_SUM_SET_SHOWING;
  constructor(public area: string) {}
}

export class InvSumRequestData implements Action {
  readonly type = INV_SUM_REQUEST_DATA;
  constructor(public filter: InventoryFilter) {}
}

export class InvSumSelectRow implements Action {
  readonly type = INV_SUM_SELECT_ROW;
  constructor(public row: any) {}
}

export class InvSumClearSelectedRow implements Action {
  readonly type = INV_SUM_CLEAR_SELECT_ROW;
}

export class InvDtlInit implements Action {
  readonly type = INV_DTL_INIT;
}

export class InvDtlSetShowing implements Action {
  readonly type = INV_DTL_SET_SHOWING;
  constructor(public area: string) {}
}

export class InvDtlSelectRow implements Action {
  readonly type = INV_DTL_SELECT_ROW;
  constructor(public row: any) {}
}

export class InvDtlClearSelectedRow implements Action {
  readonly type = INV_DTL_CLEAR_SELECT_ROW;
}

export class InvDtlRequestData implements Action {
  readonly type = INV_DTL_REQUEST_DATA;
  constructor(public filter: InventoryFilter) {}
}

export class InvItemLotReuiredRequestData implements Action {
  readonly type = INV_ITEM_LOT_REQ_DATA;
  constructor(public item: string) {}
}

export class InvItemLotReuiredRequestDataSuccess implements Action {
  readonly type = INV_ITEM_LOT_REQ_DATA_SUCESS;
  constructor(public lotrequiredItem: LotRequiredItem[]) {}
}

export class InvLotInit implements Action {
  readonly type = INV_LOT_INIT;
}

export class InvLotSetShowing implements Action {
  readonly type = INV_LOT_SET_SHOWING;
  constructor(public area: string) {}
}

export class InvLotRequestData implements Action {
  readonly type = INV_LOT_REQUEST_DATA;
  constructor(public data: any) {}
}

export type InventoryActions =
  | InvSumInit
  | InvSumSetFilter
  | InvSumClearFilter
  | InvSumSetShowing
  | InvSumRequestData
  | InvSumSelectRow
  | InvSumClearSelectedRow
  | InvDtlSetShowing
  | InvDtlInit
  | InvDtlSelectRow
  | InvDtlClearSelectedRow
  | InvDtlRequestData
  | InvItemLotReuiredRequestData
  | InvItemLotReuiredRequestDataSuccess
  | InvLotInit
  | InvLotSetShowing
  | InvLotRequestData;
